import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  React,
  MDXTag
};